import { render, staticRenderFns } from "./tabMaster.vue?vue&type=template&id=1b96fa60&scoped=true&"
import script from "./tabMaster.vue?vue&type=script&lang=js&"
export * from "./tabMaster.vue?vue&type=script&lang=js&"
import style0 from "./tabMaster.vue?vue&type=style&index=0&id=1b96fa60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b96fa60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b96fa60')) {
      api.createRecord('1b96fa60', component.options)
    } else {
      api.reload('1b96fa60', component.options)
    }
    module.hot.accept("./tabMaster.vue?vue&type=template&id=1b96fa60&scoped=true&", function () {
      api.rerender('1b96fa60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/AeBooking/tabs/tabMaster.vue"
export default component.exports